var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShippericon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#F36F2E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 54,
    height: 54,
    rx: 27,
    stroke: "#F14810",
    strokeOpacity: 0.18,
    strokeWidth: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9702 17C28.4341 17 26.9608 17.6102 25.8746 18.6964C24.7884 19.7827 24.1782 21.2559 24.1782 22.792C24.1782 24.3282 24.7884 25.8014 25.8746 26.8876C26.9608 27.9738 28.4341 28.5841 29.9702 28.5841C31.5064 28.5841 32.9796 27.9738 34.0658 26.8876C35.152 25.8014 35.7623 24.3282 35.7623 22.792C35.7623 21.2559 35.152 19.7827 34.0658 18.6964C32.9796 17.6102 31.5064 17 29.9702 17ZM23.792 31.6732C22.2559 31.6732 20.7827 32.2834 19.6964 33.3696C18.6102 34.4558 18 35.9291 18 37.4652V39.3001C18 40.4647 18.8433 41.4563 19.9925 41.6432C26.6 42.7228 33.3404 42.7228 39.948 41.6432C40.5041 41.5526 41.0099 41.2672 41.375 40.838C41.74 40.4087 41.9404 39.8636 41.9404 39.3001V37.4652C41.9404 35.9291 41.3302 34.4558 40.244 33.3696C39.1578 32.2834 37.6845 31.6732 36.1484 31.6732H35.6232C35.3375 31.6732 35.0533 31.7195 34.783 31.806L33.4454 32.2431C31.1873 32.9802 28.7532 32.9802 26.495 32.2431L25.1574 31.806C24.8866 31.7179 24.6035 31.673 24.3187 31.6732H23.792Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShippericon);
export default __webpack_public_path__ + "static/media/shippericon.c56daae47d64770bc1110b4287e28763.svg";
export { ForwardRef as ReactComponent };